import styled from 'styled-components'

const StyledWorks = styled.div`
  .work-steps {
    padding-top: 20px;
    grid-gap: 40px;
    display: grid;

    .work-step-container {
      display: grid;
      grid-gap: 20px;

      .work-step {
        border-radius: 6px;
        border: 1px solid ${({ theme }) => theme.colors.gray[200]};
        text-align: center;
        display: grid;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 40px;
        justify-items: center;
        align-content: center;
        grid-gap: 1rem;

        .work-step-title {
          font-size: 18px;
          max-width: 250px;
          font-weight: 400;
          display: block;
          font-family: ${({ theme }) => theme.fonts.lexend};
          color: ${({ theme }) => theme.colors.gray[600]};
          line-height: 26px;

          mark {
            color: ${({ theme }) => theme.colors.green[400]};
            font-weight: 500;
            background-color: transparent;
          }
        }

        .work-step-description {
          font-size: 14px;
          color: ${({ theme }) => theme.colors.gray[500]};
          max-width: 250px;
          line-height: 18px;
        }
      }

      .work-step-image {
        border-radius: 6px;
        overflow: hidden;
        pointer-events: none;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }

  .work-step-number {
    height: 40px;
    width: 40px;
    left: 1rem;
    top: -20px;
    font-family: ${({ theme }) => theme.fonts.nunito};
    background-color: ${({ theme }) => theme.colors.green[400]};
    border-radius: 50%;
    font-size: 20px;
    font-weight: 600;
    box-shadow: 0 1px 2px 0px #00000038, 0 0 0 4px ${({ theme }) => theme.colors.background};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.background};
    position: absolute;
  }

  .top-content {
    width: 100%;
    margin-bottom: 40px;
    position: relative;

    .back-btn {
      border-radius: 50%;
      color: ${({ theme }) => theme.colors.gray[500]};
      border: none;
      background-color: ${({ theme }) => theme.colors.gray[100]};
      transition: 0.2s;
      margin-bottom: 20px;

      &:hover {
        color: ${({ theme }) => theme.colors.gray[600]};
        background-color: ${({ theme }) => theme.colors.gray[200]};
      }
    }
  }

  .share-link-input-container {
    width: 100%;

    .share-link-input-label {
      color: ${({ theme }) => theme.colors.gray[700]};
      font-weight: 600;
      display: block;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .share-link-input {
      border-radius: 5px;
      padding-left: 1rem;
      color: ${({ theme }) => theme.colors.gray[700]};
      height: 50px;
      border: 1.5px solid ${({ theme }) => theme.colors.green[400]};
      align-items: center;
      justify-content: space-between;
      width: 100%;
      display: flex;

      span {
        overflow: hidden;
      }

      .copy-link-btn {
        height: 48px;
        background-color: ${({ theme }) => theme.colors.green[400]};
        color: ${({ theme }) => theme.colors.background};
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  .payout-details {
    margin-top: 40px;

    h3 {
      font-size: 17px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.gray[700]};
      letter-spacing: -0.01rem;
      text-align: center;
      font-family: ${({ theme }) => theme.fonts.lexend};

      b {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.green[400]};
      }
    }

    .payout-detail-grid {
      display: grid;
      padding-top: 40px;
      grid-gap: 40px 20px;
      max-width: 500px;
      margin: 0 auto;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

      .payout-detail {
        background-color: ${({ theme }) => theme.colors.gray[50]};
        border: 1px solid ${({ theme }) => theme.colors.gray[200]};
        color: ${({ theme }) => theme.colors.gray[600]};
        position: relative;
        height: 135px;
        font-size: 14px;
        display: grid;
        justify-content: center;
        align-items: center;
        align-content: center;
        text-align: center;
        border-radius: 6px;
        grid-gap: 10px;
        font-family: ${({ theme }) => theme.fonts.lexend};

        b {
          font-size: 40px;
          font-weight: 300;
          color: ${({ theme }) => theme.colors.green[400]};
        }
      }
    }

    .payout-details-disclaimer {
      display: block;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[500]};
      text-align: center;
      max-width: 500px;
      margin: 20px auto 0 auto;
    }

    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .work-steps {
      padding-top: 40px;
      grid-gap: 40px;

      .work-step-container {
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .top-content {
      .back-btn {
        position: absolute;
        left: calc(-35px - 32px);
      }
    }
  }
`

export default StyledWorks
